import { render, staticRenderFns } from "./stuAttestationAnalysis.vue?vue&type=template&id=0743f6b0&scoped=true&"
import script from "./stuAttestationAnalysis.vue?vue&type=script&lang=js&"
export * from "./stuAttestationAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./stuAttestationAnalysis.vue?vue&type=style&index=0&id=0743f6b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743f6b0",
  null
  
)

export default component.exports